<template>
  <div>
    <search-agents-module-product @submit="submitSearch" />

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findAgentsModuleProducts } from '@/api/agents_module_product'
import { formatFloat } from '@/utils/filter'
import Pagination from '@/components/Pagination'
import SearchAgentsModuleProduct from '@/views/agents_module_products/Search'

export default {
  name: 'AgentsModuleProductList',
  components: {
    Pagination,
    SearchAgentsModuleProduct
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {
        effective: '1',
        per_page: 10
      },
      columns: [
        {
          title: '模组厂商',
          dataIndex: 'module_producer_name',
          width: 180
        },
        {
          title: '模组型号',
          dataIndex: 'module_model_name',
          width: 180
        },
        {
          title: '单价(元/片)',
          dataIndex: 'unit_price',
          width: 140,
          customRender: formatFloat
        },
        {
          title: '有效性',
          dataIndex: 'effective',
          width: 100
        },
        {
          title: '导入时间',
          dataIndex: 'created_at',
          width: 170
        }
      ]
    }
  },
  computed: {
    agentId() {
      if (this.$route.query.agent_id) {
        return parseInt(this.$route.query.agent_id)
      }
      return this.$store.getters.userAgentId
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search
      )
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findAgentsModuleProducts(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
